// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
import useTranslation from "next-translate/useTranslation";
import PropTypes from "prop-types";

import { Box, Button, Card, Grid, Typography } from "@/components/core";
import { useShortcutMenuStore } from "@/store/shortcut-menu";
import { DraggableShortcuts } from "./draggable-shortcuts";

export function ShortCutsMenu() {
  const { t } = useTranslation("common");

  const isEditing = useShortcutMenuStore((state: any) => state.isEditing);
  const setIsEditing = useShortcutMenuStore((state: any) => state.setIsEditing);

  return (
    <Card sx={{ padding: 3 }}>
      <Grid spacing={2} wrap="nowrap" justifyContent="space-between">
        <Grid.Item xs={2}>
          <Typography variant="h5">{t("shortcuts")}</Typography>
        </Grid.Item>
        <Grid.Item xs={8}>
          <DraggableShortcuts />
        </Grid.Item>
        <Grid.Item xs={2}>
          <Box sx={{ textAlign: "end" }}>
            <Button sx={{ fontWeight: "bold" }} onClick={() => setIsEditing(!isEditing)}>
              {!isEditing ? t("edit") : t("confirm")}
            </Button>
          </Box>
        </Grid.Item>
      </Grid>
    </Card>
  );
}

DraggableShortcuts.propTypes = {
  shortcuts: PropTypes.array,
  editing: PropTypes.bool,
  onDragEnd: PropTypes.func,
};
